import { Outlet } from 'react-router-dom';
import Footer from '../components/Footer';
import Banner from '../components/Banner';
import Navigation from '../components/Navigation';

const Layout = () => {
  return (
    <div className="bg-light min-h-screen flex flex-col bg-white">
      <Navigation />
      <div className="flex-1">
        <Banner />
        <Outlet />
      </div>
      <Footer />
    </div>
  );
};

export default Layout;
